<template>
  <div>
    <h3 class="u-mb-20">{{ id ? 'Editar grupo de consumo' : 'Novo grupo de consumo' }}</h3>

    <el-form :model="dados" label-position="top">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="10">
          <el-form-item label="Nome"><el-input v-model="dados.nome" placeholder="Ex.: Integral manhã"></el-input></el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="Instituição">
            <el-select v-model="dados.instituicao_id" filterable style="width:100%" :disabled="!!id">
              <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6">
          <el-form-item label="Turno"><el-input v-model="dados.turno"></el-input></el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="Descrição"><el-input v-model="dados.descricao" type="textarea" :rows="2"></el-input></el-form-item>

      <el-form-item label="Ativo"><el-switch v-model="dados.situacao"></el-switch></el-form-item>

      <div class="u-text-right u-mb-20">
        <router-link to="/admin/merenda/grupo-consumo" class="u-mr-10"><el-button>VOLTAR</el-button></router-link>
        <el-button type="primary" @click="salvar">SALVAR</el-button>
      </div>
    </el-form>

    <div v-if="id">
      <h4 class="u-mb-10">Alunos no grupo ({{ alunos.length }})</h4>

      <table class="table table-striped" v-if="alunos.length">
        <thead><tr><th style="width:56px;"></th><th>Aluno</th><th style="width:130px;">Desde</th><th style="width:110px;" class="u-text-center">Ação</th></tr></thead>
        <tbody>
          <tr v-for="a in alunos" :key="a.vinculo_id">
            <!--
              MER 28 — identificação visual de quem consome a merenda. A imagem vem pela rota
              AUTENTICADA (o componente cuida disso); a tela nunca conhece o caminho do arquivo.
            -->
            <td>
              <!--
                MER 28 — o profissional da merenda INSERE a foto aqui, na própria tela em que
                identifica o aluno. `podeEnviarFoto` só decide se a tela oferece; o Service
                valida perfil, escopo e conteúdo, e recusa mesmo que o botão apareça.
              -->
              <foto-pessoa endpoint="api/merenda/aluno-foto" :id="a.aluno_id" :nome="a.nome"
                           :tamanho="40" :editavel="podeEnviarFoto"></foto-pessoa>
            </td>
            <td>{{ a.nome }}</td>
            <td>{{ a.data_vinculo }}</td>
            <td class="u-text-center">
              <el-button @click="desvincular(a)" title="Desfazer vínculo" type="warning" icon="el-icon-close" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="u-fs-12 u-mb-10">Nenhum aluno vinculado.</div>

      <h4 class="u-mt-20 u-mb-10">Adicionar alunos</h4>

      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="24" :sm="8">
          <el-checkbox v-model="filtroCand.com_restricao" @change="buscarCandidatos">Somente com restrição alimentar</el-checkbox>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-input v-model="filtroCand.turno" placeholder="Turno" @keyup.native.enter="buscarCandidatos"></el-input>
        </el-col>
        <el-col :xs="24" :sm="8" class="u-text-right">
          <el-button @click="buscarCandidatos" type="info" plain icon="el-icon-search">BUSCAR CANDIDATOS</el-button>
        </el-col>
      </el-row>

      <table class="table table-striped" v-if="candidatos.length">
        <thead>
          <tr>
            <th style="width:50px;"><el-checkbox v-model="todos" @change="marcarTodos"></el-checkbox></th>
            <th style="width:56px;"></th>
            <th>Aluno</th>
            <th style="width:170px;">Restrição alimentar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in candidatos" :key="c.aluno_id">
            <td><el-checkbox v-model="selecionados" :label="c.aluno_id"><span></span></el-checkbox></td>
            <td>
              <foto-pessoa endpoint="api/merenda/aluno-foto" :id="c.aluno_id" :nome="c.nome" :tamanho="40"></foto-pessoa>
            </td>
            <td>{{ c.nome }}</td>
            <td>
              <!-- Minimização: informa QUE há restrição, sem revelar qual. -->
              <el-tag v-if="c.possui_restricao" size="mini" type="warning">possui</el-tag>
              <span v-else class="u-fs-12">—</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="u-fs-12">Nenhum candidato encontrado com os filtros atuais.</div>

      <div class="u-text-right u-mt-10" v-if="candidatos.length">
        <el-button type="primary" :disabled="!selecionados.length" @click="vincular">
          VINCULAR {{ selecionados.length }} ALUNO(S)
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import FotoPessoa from '@/shared/foto-pessoa/foto-pessoa.vue'

export default {
  components: { FotoPessoa },

  computed: {
    /*
     * Perfis que o backend aceita em `api/merenda/aluno-foto-enviar/{id}`. Espelho da matriz;
     * a decisão real é do Service.
     */
    podeEnviarFoto () {
      return [0, 1, 3, 4, 5, 6, 7, 8, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1
    }
  },

  data: () => ({
    id: null, instituicoes: [], alunos: [], candidatos: [], selecionados: [], todos: false,
    filtroCand: { com_restricao: false, turno: '' },
    dados: { nome: '', instituicao_id: '', periodo_letivo_id: '', turno: '', descricao: '', situacao: true }
  }),
  mounted () {
    this.id = this.$route.params.id || null
    this.carregarInstituicoes()
    if (this.id) { this.carregar(); this.carregarAlunos() }
  },
  methods: {
    carregarInstituicoes () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`, this.$store.getters.getHeaderAuth)
        .then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : (r.data.data || []) })
        .catch(() => { this.instituicoes = [] })
    },

    carregar () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/getById/` + this.id, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dados = Object.assign(this.dados, r.data)
        }).catch(e => this.$store.commit('throwException', e))
    },
    carregarAlunos () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/${this.id}/alunos`, this.$store.getters.getHeaderAuth)
        .then(r => { this.alunos = (r.data && r.data.erro) ? [] : (r.data.alunos || []) })
        .catch(() => { this.alunos = [] })
    },
    buscarCandidatos () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/${this.id}/candidatos`, this.filtroCand, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.candidatos = (r.data && r.data.erro) ? [] : (r.data.candidatos || [])
          this.selecionados = []; this.todos = false
        }).catch(e => this.$store.commit('throwException', e))
    },
    marcarTodos (v) { this.selecionados = v ? this.candidatos.map(c => c.aluno_id) : [] },
    vincular () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/vincular`,
        { grupo_consumo_id: this.id, alunos: this.selecionados }, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          window.eventBus.$emit('alert', { msg: `Vinculados: ${r.data.vinculados}`, type: 'success' })
          this.carregarAlunos(); this.buscarCandidatos()
        }).catch(e => this.$store.commit('throwException', e))
    },
    desvincular (a) {
      this.$msgbox.prompt('Motivo do desvínculo (opcional)', 'Desfazer vínculo', { confirmButtonText: 'Confirmar', cancelButtonText: 'Cancelar' })
        .then(({ value }) => {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/desvincular/` + a.vinculo_id,
            { motivo: value }, this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              window.eventBus.$emit('alert', { msg: 'Vínculo desfeito. O histórico foi preservado.', type: 'success' })
              this.carregarAlunos()
            }).catch(e => this.$store.commit('throwException', e))
        }).catch(() => {})
    },
    salvar () {
      const url = this.id
        ? `${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/update/` + this.id
        : `${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/store`
      this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$router.push('/admin/merenda/grupo-consumo')
        }).catch(e => this.$store.commit('throwException', e))
    }
  }
}
</script>
